module.exports = __webpack_public_path__ + "img/turk-bg.b09b9536.jpg";